import { Building2, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="p-2 bg-secondary/20 rounded-lg">
                <Building2 className="h-6 w-6 text-secondary" />
              </div>
              <span className="text-xl font-bold">BizMatch</span>
            </div>
            <p className="text-primary-foreground/80 mb-4">
              Australia's premier marketplace for buying and selling businesses.
              <br /><br />
              <span className="text-secondary font-semibold">Available on web and mobile app.</span> We connect business sellers with qualified, motivated buyers — helping deals get done faster since 2024.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/explore" className="text-primary-foreground/80 hover:text-secondary transition-colors">Browse Listings</Link></li>
              <li><Link to="/franchises" className="text-primary-foreground/80 hover:text-secondary transition-colors">Franchises</Link></li>
              <li><Link to="/list-business" className="text-primary-foreground/80 hover:text-secondary transition-colors">For Brokers</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/help" className="text-primary-foreground/80 hover:text-secondary transition-colors">Help Center</Link></li>
              <li><Link to="/contact" className="text-primary-foreground/80 hover:text-secondary transition-colors cursor-pointer select-none touch-manipulation">Contact Us</Link></li>
              <li><Link to="/sign-up" className="text-primary-foreground/80 hover:text-secondary transition-colors cursor-pointer select-none touch-manipulation">Getting Started</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-primary-foreground/80">
                <Mail className="h-4 w-4" />
                <span>hello@bizmatch.com.au</span>
              </div>
              <div className="flex items-center gap-2 text-primary-foreground/80">
                <Phone className="h-4 w-4" />
                <span>+61 418 616 704</span>
              </div>
              <div className="flex items-center gap-2 text-primary-foreground/80">
                <MapPin className="h-4 w-4" />
                <span>2/290 Boundary St, Spring Hill, QLD 4000</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-primary-foreground/60 text-sm">
            © 2024 BizMatch. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm mt-4 md:mt-0">
            <Link to="/privacy" className="text-primary-foreground/60 hover:text-secondary transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-primary-foreground/60 hover:text-secondary transition-colors">Terms of Service</Link>
            <Link to="/cookies" className="text-primary-foreground/60 hover:text-secondary transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}